/**
 * Shared validation schemas — Single Source of Truth
 * Rule 15: No duplication across backend/frontend
 */

// Address schemas (used in 15+ forms)
export * from './address.schema';

// Company info schemas (onboarding, tenant admin)
export * from './company.schema';

// Tax number validation (country-specific patterns)
export * from './tax-number.validator';

// Zod schema helpers (optionalString, optionalEmail, optionalUuid, ...)
export * from './zod-helpers';
